module.exports = __webpack_public_path__ + "resources/img/img_sqml_di1.3ce2b00d95ab3e428abe60d543102205.png";